.welcomeContainer {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	height: 100%;
	padding-bottom: 1rem;
	width: 100%;

	.welcomeTitle {
		margin-top: -1rem;
		color: #444444;
		font-weight: 600;
		font-size: 1.75rem;
		line-height: 1.4;
	}

	.welcomeDescription {
		line-height: 1.5;
		font-size: 0.9375rem;
		font-weight: 400;
		color: #333333;
		width: 55vw;
		text-align: center;
	}
}

.verityTitleWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.3125rem;
	justify-content: center;
	align-items: center;

	& .verityTitle {
		font-weight: 700;
		font-size: 1.75rem;
		color: #212121;
		line-height: 1.4;
		text-align: center;
	}
}

.imageContainer {
	width: 32vw;
	aspect-ratio: 575/300;
	/*UI teams want button and image to be "center aligned", but it is already center aligned,
        so manually adjusting so visually it looks center aligned*/
	margin-left: 1.5rem;

	svg {
		width: 100%;
		height: 100%;
	}
}

.startCheckButton:global(.MuiButton-root) {
	height: 40px;
	width: fit-content;
	margin-top: 0.9375rem;
	font-size: 0.9375rem;
}

.quizInfoContainer {
	display: grid;
	grid-template-columns: max-content 1fr;
	row-gap: 0.75rem;
	column-gap: 1.875rem;

	& .quizLabel {
		color: #333333;
		font-size: 0.9375rem;
		line-height: 1.5;
		font-weight: 600;
	}

	& .quizValue {
		color: #333333;
		font-weight: 400;
		font-size: 0.9375rem;
		line-height: 1.5;
	}
}

@media (max-width: 768px) {
	.welcomeContainer {
		padding-top: 2rem;

		& .welcomeDescription {
			width: 100%;
		}
	}

	.imageContainer {
		width: 60vw;
	}

	.verityTitleWrapper {
		flex-direction: column;
	}
}
